import { NgModule, enableProdMode } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { HttpClientModule } from '@angular/common/http';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { SignalRModule } from 'ng2-signalr';
import { SignalRConfiguration, ConnectionTransports } from 'ng2-signalr';

import { appRouting } from './app.routing';
import { AppComponent } from './app.component';
import { BlankComponent } from './blank.component';
// import {
//   TestContentService, TestTakerService, PreviewService, ResponseService, HtmlService, TimerService, LoggerService,
//   AuthService, RepeatableRandomGeneratorService, AnswerKeyService, ScoringPageService
// } from './services';
import { ScoringPageService } from './services/scoring-page.service';
import { AnswerKeyService } from './services/answerkey.service';
import { RepeatableRandomGeneratorService } from './services/repeatable-random-generator.service';
import { AuthService } from './services/auth.service';
import { LoggerService } from './services/logger.service';
import { TimerService } from './services/timer.service';
import { HtmlService } from './services/html.service';
import { ResponseService } from './services/response.service';
import { PreviewService } from './services/preview.service';
import { TestTakerService } from './services/test-taker.service';
import { TestContentService } from './services/test-content.service';
import { KeyboardActivityService } from './services/keyboard-activity.service';

import { MyModal } from './components/common/my-modal/my-modal.component';
import { reducers, metaReducers } from './store/reducers';
import { AppUiEffects, TestTakerEffects } from './store/effects';
import { PgRendererModule } from './components/pg-renderer/pg-renderer.module';
import { TdpModule } from './components/tdp/tdp.module';
import { SharedModule } from './components/common/shared.module';
import { DynamicComponentService } from './services/dynamic-component.service';
import { SignalRService } from './services/signalR.service';
import { FullscreenService } from './services/fullscreen.service';


@NgModule({
  imports: [
    StoreModule.forRoot(reducers, { metaReducers }),
    EffectsModule.forRoot([AppUiEffects, TestTakerEffects]),
    StoreDevtoolsModule.instrument({
      maxAge: 50
    }),
    BrowserModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    HttpModule,
    SharedModule,
    PgRendererModule,
    TdpModule,
    appRouting,
    SignalRModule.forRoot(createConfig)
  ],
  declarations: [
    AppComponent,
    BlankComponent
  ],
  providers: [
    FullscreenService,
    TestContentService,
    TestTakerService,
    PreviewService,
    KeyboardActivityService,
    ResponseService,
    HtmlService,
    TimerService,
    LoggerService,
    AuthService,
    MyModal,
    RepeatableRandomGeneratorService,
    AnswerKeyService,
    DynamicComponentService,
    ScoringPageService,
    SignalRService
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }

declare var _paragonConfig: PgRendererDto.ParagonAppConfig;
export function createConfig(): SignalRConfiguration {
  const signalRConfig = new SignalRConfiguration();
  signalRConfig.hubName = 'TestTakerHub';
  signalRConfig.url = _paragonConfig.testServerApiUrl;
  signalRConfig.logging = true;
  signalRConfig.transport = [ConnectionTransports.webSockets];
  return signalRConfig;
}



// WEBPACK FOOTER //
// C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/app.module.ts